@if (canBeDisplayed) {
<div (offClick)="toggle(false)"
     [offClickOff]="!openState.value || client.sizeId < 2 || isNotifyMeOpen"
     class="b-a b-col-42 bg-col-w pos-relative left">
    <!-- heading -->
    <div class="p-l-5 p-r-5 flex flex-middle flex-justify-between cursor-pointer col-1"
         style="height: 48px"
         (click)="toggle()">
        <!-- title -->
        <div class="flex-grow">
            <p class="s2">
                @if(value) {
                @if(multipleVariant) {
                {{attr.model.data?.label}}: {{value.label}}
                } @else {
                {{value.label}}
                }
                } @else {
                {{'Select %' | translate : attr.model.data?.label}}
                }
            </p>
            @if(!multipleVariant) {
            @if(value?.product?.inStockEstimationMessage) {
            <p class="p3"> {{'Estimated in stock' | translate}}
                {{value.product.inStockEstimationMessage}}</p>
            } @else if(value && isOutOfStock(value)) {
            <p class="p3 col-6">
                {{'Out of Stock' | translate}}
            </p>
            }
            }
        </div>

        <!-- icon -->
        @if(!!options.length) {
        <i [toggleClass]="'_is-up !_is-down'"
           [toggleClassBy]="openState"
           class="icon-chevron inline-flex _chevron"></i>
        }
    </div>

    <!-- body -->
    <div *ifSize="'XL'"
         [hideUp]="openState">
        <div class="bg-col-w">
            <ng-container *ngTemplateOutlet="optionsTpl"></ng-container>
        </div>
    </div>

    <div *ifSize="'SM'"
         [class._isOpen]="openState.value">
        <div class="_mainOverlay"
             (click)="toggle(false)">
        </div>
        <div class="bg-col-w p-t-5 p-b-8 _mobileSelector">
            <div class="flex flex-justify-between p-r-5 p-l-5 p-b">
                <p class="s2">
                    {{'Select %' | translate : attr.model.data?.label}}
                </p>
                <ng-content></ng-content>
            </div>
            <ng-container *ngTemplateOutlet="optionsTpl"></ng-container>
        </div>
    </div>
</div>

<ng-template #optionsTpl>
    @for (option of options; track $index; let last = $last) {

    <div class="p-r p-l"
         [class.bg-col-4]="value && value.value === option.value"
         (click)="pick(option)">
        <div class="cursor-pointer p-t-3 p-b-3 p-t-4-s p-b-4-s p-t-4-m p-b-4-m b-t b-col-42 flex flex-justify-between"
             [ngClass]="(isNotifyMe(option) || isOutOfStock(option))  ? 'flex-top' : 'flex-middle'">
            <p class="s2"
               [ngClass]="(isNotifyMe(option) || isOutOfStock(option)) ? 'col-12' : 'col-1'">
                {{option.label}}</p>

            @if(displayWarnings) {
            @switch (isNotifyMe(option)) {
            @default {

            @if(option.product.isPreOrder) {
            <p class="p2 inline-flex">{{'Pre-order'}}</p>
            }
            @else if (option.product.isBackOrder) {
            <p class="p2 inline-flex">{{'Back Order'}}</p>
            }
            @else if (isOutOfStock(option)) {
            <p class="p2 inline-flex col-6">{{'Sold Out'}}</p>
            }
            @else if(productsLeft(option) < 6
              &&
              productsLeft(option)> 0) {
                <p class="p2"
                   [ngClass]="productsLeft(option) === 1 ? 'col-6' : 'col-11'">
                    {{'Only % left' | translate: productsLeft(option)}}
                </p>
                }
                }
                @case (true) {
                <div class="right">
                    <div class="inline-flex flex-middle">
                        <i class="icon-email inline-flex m-r-2"></i>
                        <p class="p2 underline">{{'Notify me'}}</p>
                    </div>
                    @if(option.product.inStockEstimationMessage) {
                    <p class="p3 p-t-1"> {{'Estimated in stock' | translate}}
                        {{option.product.inStockEstimationMessage}}</p>
                    }
                </div>
                }
                }
                }
        </div>
    </div>
    }
</ng-template>
}